import { Component, Inject } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { RouterAnimation } from './app-router.animation';
import { Angulartics2AppInsights } from 'angulartics2/appinsights';
import { AppInsights } from 'applicationinsights-js';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs';
import { InsurancesService } from './ordering-platform/insurance-products/services/insurances.dataservice';
import { LowCreditService } from './ordering-platform/services/helpers/LowCredit.service';
import { Title } from '@angular/platform-browser';
import { DataService } from './ordering-platform/services/dataservice.service';
import { DOCUMENT } from '@angular/common';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  animations: [RouterAnimation]
})

export class AppComponent {
  title = 'cls';

  // detect browser
  browserD: string = null;
  versionD: string = null;
  ar: string[];

  // detect device
  private _deviceInfo = null;
  private _isMobile = false;
  private _isTablet = false;
  private _isDesktop = false;

  // alternate navbar for UK/EU
  isEuro: boolean;
  is_frontend: boolean;

  isLoginPage;

  isCreditLow;
  isLowCreditAlertOpen;

  BrowserDetect = {
    init: function () {
      this.browserD = this.searchString(this.dataBrowser) || 'Other';
      this.versionD = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || 'Unknown';
      return this.ar = [this.browserD, this.versionD];
    },
    ar: [this.browserD, this.versionD],
    searchString: function (data) {
      for (let i = 0; i < data.length; i++) {
        const dataString = data[i].string;
        this.versionSearchString = data[i].subString;

        if (dataString.indexOf(data[i].subString) !== -1) {
          return data[i].identity;
        }
      }
    },
    searchVersion: function (dataString) {
      const index = dataString.indexOf(this.versionSearchString);
      if (index === -1) {
        return;
      }

      const rv = dataString.indexOf('rv:');
      if (this.versionSearchString === 'Trident' && rv !== -1) {
        return parseFloat(dataString.substring(rv + 3));
      } else {
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      }
    },
    dataBrowser: [
      { string: navigator.userAgent, subString: 'Edge', identity: 'MS Edge' },
      { string: navigator.userAgent, subString: 'MSIE', identity: 'Explorer' },
      { string: navigator.userAgent, subString: 'Trident', identity: 'Explorer' },
      { string: navigator.userAgent, subString: 'Firefox', identity: 'Firefox' },
      { string: navigator.userAgent, subString: 'Opera', identity: 'Opera' },
      { string: navigator.userAgent, subString: 'OPR', identity: 'Opera' },
      { string: navigator.userAgent, subString: 'Chrome', identity: 'Chrome' },
      { string: navigator.userAgent, subString: 'Safari', identity: 'Safari' }
    ]
  };

  constructor(
    private _router: Router,
    private _deciveService: DeviceDetectorService,
    _angularitcs: Angulartics2AppInsights,
    private _insuranceService: InsurancesService,
    private _lowCreditService: LowCreditService,
    private lowCreditService: LowCreditService,
    titleService: Title,
    private _data_service: DataService,
    @Inject(DOCUMENT) private doc: any
  ) {
    this.setGTagManager()
    this.setUserBackWidget()

    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config',
          environment.googleAnlaytics,
          {
            'page_path': event.urlAfterRedirects
          }
        );
      }
    });

    AppInsights.downloadAndSetup({ instrumentationKey: environment.analytics });
    _angularitcs.startTracking();

    this.BrowserDetect.init();

    this._data_service.ExtendToken();
    _router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (
          window.location.pathname === '/' ||
          window.location.pathname === '/data' ||
          window.location.pathname === '/groupservices' ||
          window.location.pathname === '/news' ||
          window.location.pathname === '/events' ||
          window.location.pathname === '/browser-support' ||
          window.location.pathname === '/register'
        ) {
          this.is_frontend = true;
        } else {
          this.is_frontend = false;
        }

        if (event.url === '/login') {
          this.isLoginPage = true;
        } else {
          this.isLoginPage = false;
        }

        const url = event.url.split('?')[0];

        // IF YOU REMOVE THIS INSURANCES WILL NOT WORK
        if (url === '/ordering/newcase/insurance') {
          _insuranceService.sendNewInsurance(false);
        } else if (event.url === '/ordering/newcase/insurance/policydetail') {
          if (_insuranceService.Basket.length > 0) {
            _insuranceService.sendNewInsurance(true);
          } else {
            _router.navigate(['ordering/newcase/insurance']);
          }
        }
      } else if (event instanceof NavigationEnd) {
        this.BrowserDetect.init();
        if (window.location.pathname !== '/browser-support'
          && this.BrowserDetect.ar[0] === 'Explorer'
          && parseInt(this.BrowserDetect.ar[1], 10) < 9) {
          window.location.pathname = '/browser-support';
        }


        // update header-navigation if UK || EU
        if (window.location.pathname !== '/europe') { this.isEuro = false; } else { this.isEuro = true; }

        // browser detect
        this.BrowserDetect.init();

        if (this.BrowserDetect.ar[0] === 'Explorer' && parseInt(this.BrowserDetect.ar[1], 10) < 9) {
          window.location.href = environment.frontend + 'browser-support';
        }

        const title = this.getTitle(_router.routerState, _router.routerState.root).join('-');
        if (title) { titleService.setTitle(title); }
        this._data_service.loggedIn.subscribe((res) => {
          if (res) {
              this.lowCreditService.getUserCredit().then((res) => {
                this.isCreditLow = this._lowCreditService.isCreditLow;
                this.isLowCreditAlertOpen = this._lowCreditService.alertOpen;
              }, (error) => {
                if (error && error.networkError && error.networkError.status === 403) {
                  this._router.navigate(['/']);
                }

                if (error.status == 401 || error.status == 403) {
                  this._router.navigate(['/']);
                }
            });
          }
        });
      }
    });
  }

  private setGTagManager() {

    const s = this.doc.createElement('script');
    s.type = 'text/javascript';
    s.innerHTML = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push'
      + '({\'gtm.start\':new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)'
      + '[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src='
      + '\'https://www.googletagmanager.com/gtag/js?id=\'+i+dl;f.parentNode.insertBefore(j,f);})'
      + '(window,document,\'script\',\'dataLayer\',\'' + environment.googleAnlaytics + '\');';
    const head = this.doc.getElementsByTagName('head')[0];
    head.appendChild(s);
  }

  private setUserBackWidget() {

    const userback = this.doc.createElement('script')
    userback.type = 'text/javascript'
    userback.innerHTML = "Userback = window.Userback || {}; Userback.access_token = '" + environment.userbackAccessToken + "'; "
      + "(function(id) { var s = document.createElement('script'); s.async = 1; s.src = 'https://static.userback.io/widget/v1.js';"
      + " var parent_node = document.head || document.body;  parent_node.appendChild(s); })('userback-sdk');"

    const body = this.doc.getElementsByTagName('body')[0]
    body.appendChild(userback)
  }

  getTitle(state, parent) {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }


  detectDevice(): void {
    this._deviceInfo = this._deciveService.getDeviceInfo();
    this._isMobile = this._deciveService.isMobile();
    this._isTablet = this._deciveService.isTablet();
    this._isDesktop = this._deciveService.isDesktop();
  }
}
